module.exports = __webpack_public_path__ + "static/img/science3.f8fde11b.png";